<section>
    <div class="modal-header">
        <button (click)="closeDialog()" mat-icon-button style="position: absolute; right: 5px;">
            <mat-icon>close</mat-icon>
        </button>
        <h2 style="color: #003C8A;"><mat-icon>attach_file</mat-icon> Subir Documento</h2>
    </div>
    <hr class="divider">
    <div class="modal-body">
        <form [formGroup]="uploadForm" (ngSubmit)="submitUploadCompanyDocument()">
            <section class="form-section">
             
                <mat-form-field>
                    <mat-label>Tipo Documento</mat-label>
                    <mat-select formControlName="documentType">
                        <mat-option *ngFor="let docType of docTypes$ | async"
                        [value]="docType.documentTypeId">
                            {{ docType.documentName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Descripción</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
                <ngx-file-drop
                    (onFileDrop)="droppedFile($event)"[directory]="false"
                    [multiple]="false" dropZoneLabel="Seleccione o arrastre el archivo">
                    <ng-template class="drop-zone" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <span *ngIf="!file">
                            <button (click)="openFileSelector()" type="button" color="primary" mat-raised-button>Cargar</button>
                            o arrastre el archivo
                        </span>
                        <span *ngIf="file">
                            {{ file.name}} <mat-icon class="remove-file-input" (click)="handleRemoveFile()">close</mat-icon>
                        </span>
                    </ng-template>
                </ngx-file-drop>
                
            </section>
            <section class="actions-btn">
                <button type="submit" mat-raised-button color="primary" [disabled]="!uploadForm.valid">
                    <mat-icon>upload</mat-icon>
                    Subir
                </button>
            </section>
        </form>
    </div>
</section>